import { useEffect } from 'react';
import { retriveUserOrders } from '../../actions';
import { connect } from 'react-redux';
import PointerMenu from './PointerMenu';
import './order.css'
const Order = ({ retriveUserOrders, allOrders, pendingOrders, cancelledOrders, completedOrders, loading }) => {
    useEffect(() => {
        retriveUserOrders()
    }, [retriveUserOrders])
    const menuItems = [
        {   
            'name': 'All',
            'data': allOrders
        },
        {   
            'name': 'Done',
            'data': completedOrders
        },
        {   
            'name': 'Pending',
            'data': pendingOrders
        },
        {
            'name': 'Cancelled',
            'data': cancelledOrders
        }
    ]
    return(
        <div className="containerAF max-width orders-container__user">
            <h1>Order</h1>
            <div className="order-menu">
                <PointerMenu menuItems={menuItems} loading={loading}/>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    const allOrders = state.orders
    let pendingOrders = [];
    let cancelledOrders = [];
    let completedOrders = [];
    allOrders.data.forEach(element => {
        if (element.status === 'pending'){
            pendingOrders.push(element)
        }
        else if (element.status === 'cancelled'){
            cancelledOrders.push(element)
        }
        else if (element.status === 'completed'){
            completedOrders.push(element)
        }
    });
    return {
        allOrders: allOrders.data,
        cancelledOrders: cancelledOrders,
        pendingOrders: pendingOrders,
        completedOrders: completedOrders,
        loading: allOrders.loading,
    }
}
export default connect(mapStateToProps, { retriveUserOrders })(Order)